import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { Button } from "@/components/ui/Button";
import { useTheme } from "@/hooks/useTheme";

export interface ConfirmModalProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
}

export function ConfirmModal({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor,
}: ConfirmModalProps) {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.card, borderColor: colors.border }]}>
      <ThemedText type="title" style={[styles.title, { color: colors.text }]}>
        {title}
      </ThemedText>

      <ThemedText style={[styles.message, { color: colors.text }]}>{message}</ThemedText>

      <View style={styles.actions}>
        <Button
          text={cancelText}
          onPress={onCancel}
          style={[styles.actionButton, { backgroundColor: "transparent", borderColor: colors.border }]}
          textStyle={{ color: colors.text }}
        />
        <Button
          text={confirmText}
          onPress={onConfirm}
          style={[styles.actionButton, { backgroundColor: confirmColor || colors.red?.background || colors.primary }]}
          textStyle={{ color: "white" }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    maxWidth: 400,
    minWidth: 300,
    borderRadius: 12,
    borderWidth: StyleSheet.hairlineWidth,
    padding: 24,
    boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.25)",
    elevation: 8,
  },
  title: {
    fontSize: 20,
    fontWeight: "600",
    textAlign: "center",
    marginBottom: 16,
  },
  message: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: "center",
    marginBottom: 24,
  },
  actions: {
    flexDirection: "row",
    gap: 12,
  },
  actionButton: {
    flex: 1,
    minHeight: 44,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
    borderWidth: 1,
  },
});
